import SlaughterInvoiceApi from '@/api/delivery/slaughter-invoice-api';
export default {
  namespaced: true,
  actions: {
    async create(_, {query}) {
      try {
        const response = await SlaughterInvoiceApi.create(query);
        return Promise.resolve(response.data);
      } catch {
        return await Promise.reject();
      }
    },
    async preview(_, {query}) {
      try {
        const response = await SlaughterInvoiceApi.preview(query);
        return Promise.resolve(response.data);
      } catch {
        return await Promise.reject();
      }
    },
    async print(_, {query}) {
      try {
        const response = await SlaughterInvoiceApi.print(query);
        return Promise.resolve(response.data);
      } catch {
        return await Promise.reject();
      }
    }
  }
}
